import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.storageKey = `profile-tabs:${window.location.pathname}`
    this.activateInitialTab()
    this.element.addEventListener("shown.bs.tab", this.rememberTab)
  }

  disconnect() {
    this.element.removeEventListener("shown.bs.tab", this.rememberTab)
  }

  activateInitialTab() {
    const target = window.location.hash || window.sessionStorage.getItem(this.storageKey)
    if (!target) return

    const tabButton = this.element.querySelector(`[data-bs-target="${target}"]`)
    if (!tabButton || !window.bootstrap?.Tab) return

    window.bootstrap.Tab.getOrCreateInstance(tabButton).show()
  }

  rememberTab = (event) => {
    const target = event.target.dataset.bsTarget
    if (!target) return

    window.sessionStorage.setItem(this.storageKey, target)
    window.history.replaceState(null, "", target)
  }
}
